export class SEG {
  id: string;
  name: string;
  description: string;
  organizationLevelId: string;
  organizationLevelName: string;
  code: string;
  addedToMySite?: boolean;
  siteCount?: number;
  addedAtSelectedOrgLevel?: boolean;
  mergedIntoId?: string | null;
  mergedIntoName?: string;
  archiveType?: string | null;
  updatedByUserId?: string;
  updatedByUserName?: string;
  dateCreated?: string;
  dateUpdated?: string;
  deletedByUserId?: string | null;
  deletedByUserName?: string;
  deletedDate?: string | null;
  isDeleted?: boolean;
}

export class SegRecordHistory extends SEG {
  entityId: string;
  reason?: string;
  changedFields?: string;
  changedFieldsArray?: string[];
  changedFieldSet?: Set<string>;
  dateUpdatedDisplay?: string;
}
